/* eslint-disable import/order */ /* <= reason: порядок импорта очень важен в этом месте  */
import { createApp } from 'vue';
// import ElementLocale from 'element-ui/lib/locale';
import { VueReCaptcha } from 'vue-recaptcha-v3';

// App modules
import App from '@/App.vue';
import api from '@/api';
import { I18nSetup } from '@/i18n';
import router from '@/router';
import store from '@/store';

// Init functions!
import LibsSetup from '@/setup/libs';
import PluginsSetup from '@/setup/plugins';
//@ts-expect-error wip
import ComponentsSetup from '@/setup/components';
// import Directive from '@/setup/directive';
import FiltersSetup from '@/setup/filters';
import { EventBusSetup } from '@/setup/eventBus';
import HandlersSetup from '@/setup/handlers';
import NavigationGuardsSetup from '@/setup/navigationGuards';
import AnalyticsSetup from '@/setup/analytics';
import DebugSetup from '@/setup/debug';

import { SentrySetup } from '@/setup/sentry';
//TODO: избавиться от файла после перехода на темы
//@ts-expect-error убрали в рефакторинге тем
import { config, loadStyles } from './config';
import fetchMiscSettings from '@/helpers/fetchMiscSettings';

import '@/assets/styles/tailwind.scss';
import '@/assets/styles/global.scss';
import HighchartsVue from 'highcharts-vue';

const Vue  = createApp(App);

Vue.config.performance = process.env.NODE_ENV !== 'production';

const apiConfig = {
  store,
  router,
  affiliatesBaseUrl: `${config.apiBaseUrl}/admin`,
  miscBaseUrl: `${config.apiBaseUrl}/misc`,
};

NavigationGuardsSetup();

// if (!Vue.prototype.$theme) {
//   Object.defineProperty(Vue.prototype, '$theme', {
//     value: config,
//     writable: false,
//   });
// }
// Vue.config.globalProperties.$theme = config;

I18nSetup(Vue);
LibsSetup(Vue);
PluginsSetup(Vue);
ComponentsSetup(Vue);
// Directive(Vue);
FiltersSetup(Vue);
EventBusSetup(Vue);
HighchartsVue(Vue);
DebugSetup(Vue);

// ElementLocale.i18n((key, value) => i18n.t(key, value));

Vue.use(api, apiConfig);

const initCaptcha = async () => {
  try {
    const {
      payload: {
        recaptcha: { public_key },
      },
    } = await fetchMiscSettings();

    Vue.use(VueReCaptcha, {
      siteKey: public_key,
      loaderOptions: {
        autoHideBadge: true,
      },
    });
  } catch (error) {
    window.console.error(error);
  }
};

initCaptcha();

// const VueInstance = new Vue({
//   router,
//   store,
//   i18n,
//   render: h => h(App),
// });

Vue.use(router);
Vue.use(store);

HandlersSetup(Vue);

loadStyles().then(async () => {
  await AnalyticsSetup(Vue);
  Vue.mount('#app');
});

Vue.config.globalProperties.$set = (item: any, key: string | number, value: any) => {
  item[key] = value;

  // console.trace('$set is deleted from vue 3!')
};

Vue.config.globalProperties.$delete = (item: any, key: string | number) => {
  if(Array.isArray(item)) { 
    item.splice(key as number, 1);
  } else if(typeof item === 'object' && item !== null) {
    delete item[key];
  }

  // console.trace('$delete is deleted from vue 3!')
};


if (process.env.VUE_APP_ENVIRONMENT_NAME === 'production') {
  Vue.use(SentrySetup, { router, config });
}

export default Vue;
